export default __webpack_public_path__ + "static/media/strip-nav-bg.46ee3f74.png";